// extracted by mini-css-extract-plugin
export default {"input":"TagInput_input__ztJ1E"};